import React from 'react';

import './intelligentCourse.scss';
import { lang } from '@umu/ukit-lang';
import { openIntelligentList } from '../../../@marketCommon/utils/intelligentCourse';

export const IntelligentCourse = () => {
    return (
        <div className="intel-back" onClick={openIntelligentList}>
            <pre className="intel-title">
                <span className="text1">{lang('满足企业个性化培训需求')}</span>
                <span className="text2">{lang('智能匹配优质学习资源')}</span>
            </pre>
            <div className="intel-btn">{lang('即刻体验')}</div>
        </div>
    );
};
